import $$ from '@/store/plugins/storage'
import list from './list'
import vue from 'vue'

const namespace = 'menu'
$$.setNamespace(namespace)

const state = {
  // 菜单映射表
  menuList: list,
  // 一级菜单列表
  // firstMenuList: list.firstMenuList,
  // 二级菜单列表
  secondMenuList: list.secondMenuList,
  // 三级菜单列表
  thirdMenuList: list.thirdMenuList,
  // 标签列表
  tagList: $$.get('tagList') || ['-1'],
  // 面包屑
  breadcrumbList: $$.get('breadcrumbList') || [],
  // 选中的一级菜单名称（即下标）
  firstMenu: $$.get('firstMenu') || 1,
  // 选中的标签名称（形式为0-0-0）
  tag: $$.get('tag') || '-1',
  // 是否显示
  isVisibleSecondMenu: $$.get('isVisibleSecondMenu') !== ''
    ? $$.get('isVisibleSecondMenu') : true,
  // 左侧菜单加载状态
  menuIsLoadingOver: false,
  // 工单搜索值
  allOrderKeyword: '',
  // 记录路由跳转状态
  routerLinkUrl: $$.get('routerLinkUrl') || [],
  // 菜单徽标熟练
  allBadgeCount: {}
}

const mutations = {
  _allBadgeCount(state, value) {
    for (let key in value) {
      vue.set(state.allBadgeCount, key, value[key])
    }
  },
  _routerLinkUrl(state, value) {
    state.routerLinkUrl = value
  },
  _allOrderKeyword(state, value) {
    state.allOrderKeyword = value
  },
  _menuIsLoadingOver(state, value) {
    state.menuIsLoadingOver = value
  },
  _firstMenuList(state, value) {
    state.firstMenuList = value
  },
  _secondMenuList(state, value) {
    state.secondMenuList = value
  },
  _thirdMenuList(state, value) {
    state.thirdMenuList = value
  },
  _firstMenu(state, value) {
    state.firstMenu = value
  },
  _tagList(state, value) {
    state.tagList = value
  },
  _breadcrumbList(state, value) {
    state.breadcrumbList = value
  },
  _tag(state, value) {
    state.tag = value
  },
  _isVisibleSecondMenu(state, value) {
    state.isVisibleSecondMenu = !state.isVisibleSecondMenu
  },
  _orderMenuList(state, value) {
    value.forEach((item) => {
      let menu = {}
      menu.name = item.name
      menu.routerName = 'AllOrder'
      state.secondMenuList[0][2].list.push(menu)
    })
  }
}

const actions = {
  _FirstMenuList({ commit, state, dispatch }, value) {
    let menuList = []
    let menuMappingList = state.menuList.firstMenuList
    value.firstList.forEach(val => {
      menuMappingList.forEach(val2 => {
        if (val.resource_name && val2.oldKey && val2.oldKey === val.resource_name) {
          let obj = {}
          obj.id = val.id
          obj.icon = val2.icon
          obj.name = val2.name
          obj.sort = val2.sort
          menuList.push(obj)
        }
      })
    })

    commit('_firstMenu', menuList[0].id)
    commit('_firstMenuList', menuList)
    dispatch('_SecondMenuList', value)
  },
  _SecondMenuList({ commit, state, dispatch }, value) {
    let menuList = {}
    let menuMappingList = state.menuList.secondMenuList
    let firstmenu = state.firstMenuList
    firstmenu.forEach(val => { menuList[val.id] = [] })
    value.secondList.forEach(val => {
      if (menuList[val.parent_id]) {
        menuMappingList.forEach(val2 => {
          if (val2.oldKey && val.resource_name && val2.oldKey === val.resource_name) {
            let obj = {}
            obj.id = val.id
            obj.parent_id = val.parent_id
            obj.icon = val2.icon
            obj.name = val2.name
            // arr.push(obj)
            menuList[val.parent_id].push(obj)
          }
        })
      }
    })
    commit('_secondMenuList', menuList)
    dispatch('_ThirdMenuList', value)
  },
  _ThirdMenuList({ commit, state }, value) {
    let menuList = {}
    let menuMappingList = state.menuList.thirdMenuList
    let secondMenu = state.secondMenuList
    for (let key in secondMenu) {
      secondMenu[key].forEach(val => { menuList[val.id] = [] })
    }
    value.thirdList.forEach(val => {
      menuMappingList.forEach(val2 => {
        if (val2.oldKey && val.resource_name && val2.oldKey === val.resource_name) {
          let obj = {}
          if (val2.meta) {
            obj.meta = val2.meta
          }
          obj.id = val.id
          obj.parent_id = val.parent_id
          obj.name = val2.name
          obj.routerName = val2.routerName
          if (menuList[val.parent_id]) {
            menuList[val.parent_id].push(obj)
          }
        }
      })
    })
    commit('_thirdMenuList', menuList)
    commit('_menuIsLoadingOver', true)
  },
  // 添加一个标签并选中
  _AddTag({ commit, state }, value) {
    let tagList = state.tagList
    if (tagList.indexOf(value) === -1) {
      tagList.push(value)
      commit('_tagList', tagList)
    }
    commit('_tag', value)
  },
  // 删除一个标签并设置选中规则
  _DelTag({ commit, state }, value) {
    let tagList = state.tagList
    let index // 当前选中的tag下标
    for (let i = 0; i < tagList.length; i++) {
      if (state.tag === tagList[i]) {
        index = i
      }
    }
    // 查询标签是否已存在
    for (let i = 0; i < tagList.length; i++) {
      if (value === tagList[i]) {
        tagList.splice(i, 1)
        commit('_tagList', tagList)
        // 若删除在选中的左侧 则选择 已选中的前一个
        if (i < index) {
          commit('_tag', tagList[index - 1])
        } else if (i === index) {
          // 若删除的即是选中的
          if (index === tagList.length) {
            commit('_tag', tagList[index - 1])
          } else {
            commit('_tag', tagList[index])
          }
        }
      }
    }
  },
  // 关闭所有标签
  _DelAllTag({ commit, state }, value) {
    let tagList = state.tagList.filter((val) => {
      return val === '-1'
    })
    // commit('_firstMenu', 1)
    commit('_tagList', tagList)
    commit('_tag', tagList[0])
  },
  // 关闭左侧标签
  _DelLeftTag({ commit, state }, value) {
    let tag = state.tag
    let tagList = state.tagList
    let tagIndex = 0
    tagList.forEach((val, index, arr) => {
      if (tag === val) {
        tagIndex = index
      }
    })
    tagList.splice(1, tagIndex - 1)
    commit('_tagList', tagList)
  },
  // 关闭右侧标签
  _DelRightTag({ commit, state }, value) {
    let tag = state.tag
    let tagList = state.tagList
    let tagIndex = 0
    let len = tagList.length
    tagList.forEach((val, index, arr) => {
      if (tag === val) {
        tagIndex = index
      }
    })
    tagList.splice(tagIndex + 1, len - tagIndex)
    commit('_tagList', tagList)
  },
  // 关闭其他标签
  _DelOhterTag({ commit, state }, value) {
    let tag = state.tag
    let tagList = state.tagList.filter((val) => {
      return val === '-1' || val === tag
    })
    commit('_tagList', tagList)
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/menu/index.js